import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  dateFilter: '',
  reportsDateFilter: '',
  domainFilter: [],
  organizationFilter: [],
  dataTypeRequested: '',
};

export default {
  state,
  getters,
  mutations,
  actions,
};
